import React, { useEffect, useState } from 'react';
import { useGame } from '../context/GameContext';
import Board from './Board';
import Header from './Header';
import GameOver from './GameOver';
import { KEY_CODES } from '../constants/gameConstants';
import '../styles/Game.css';
import SwipeHandler from './SwipeHandler';

const Game = () => {
  const { moveBoard, gameOver, won, keepPlaying } = useGame();
  const [showWon, setShowWon] = useState(false);

  useEffect(() => {
    if (won && !keepPlaying) {
      setShowWon(true);
    }
  }, [won, keepPlaying]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (KEY_CODES.UP.includes(e.code)) {
        moveBoard('up');
        e.preventDefault();
      } else if (KEY_CODES.DOWN.includes(e.code)) {
        moveBoard('down');
        e.preventDefault();
      } else if (KEY_CODES.LEFT.includes(e.code)) {
        moveBoard('left');
        e.preventDefault();
      } else if (KEY_CODES.RIGHT.includes(e.code)) {
        moveBoard('right');
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [moveBoard]);

  return (
    <SwipeHandler moveBoard={moveBoard}>
      <div className="game-container">
        <Header />
        <Board />
        {gameOver && <GameOver type="gameOver" />}
        {showWon && !keepPlaying && (
          <GameOver type="won" />
        )}
      </div>
    </SwipeHandler>
  );
};

export default Game;